const CREATE_DRAFT_KEY = 'pc_contest_create_draft';
const EDIT_DRAFT_PREFIX = 'pc_contest_edit_draft_';

export interface ContestFormDraft {
  formData: Record<string, unknown>;
  currentStep: number;
  generatedCouponCodes: string[];
  savedAt: string;
}

export function getCreateDraftKey(): string {
  return CREATE_DRAFT_KEY;
}

export function getEditDraftKey(contestId: string): string {
  return `${EDIT_DRAFT_PREFIX}${contestId}`;
}

export function loadDraft(storageKey: string): ContestFormDraft | null {
  try {
    const raw = localStorage.getItem(storageKey);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as ContestFormDraft;
    if (!parsed?.formData) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function saveDraft(storageKey: string, draft: Omit<ContestFormDraft, 'savedAt'>): void {
  try {
    localStorage.setItem(
      storageKey,
      JSON.stringify({
        ...draft,
        savedAt: new Date().toISOString(),
      })
    );
  } catch {
    // Ignore quota or privacy mode errors
  }
}

export function clearDraft(storageKey: string): void {
  try {
    localStorage.removeItem(storageKey);
  } catch {
    // Ignore
  }
}

export function hasMeaningfulDraftContent(
  formData: Record<string, unknown>,
  currentStep: number
): boolean {
  if (currentStep > 1) return true;
  if (String(formData.name || '').trim()) return true;
  if (String(formData.description || '').trim()) return true;
  if (String(formData.theme_name || '').trim()) return true;
  if (Array.isArray(formData.theme_keywords) && formData.theme_keywords.length > 0) return true;
  if (formData.cover_image) return true;

  const dateFields = [
    'submission_start',
    'submission_deadline',
    'voting_start',
    'voting_end',
    'winner_announcement',
  ];
  return dateFields.some((field) => Boolean(formData[field]));
}
